import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="document-expiration"
export default class extends Controller {
  static targets = ["trigger", "menu", "customFields", "customDate"]

  positionMenu() {
    const triggerRect = this.triggerTarget.getBoundingClientRect()
    const menuWidth = 256
    const margin = 8

    this.menuTarget.style.top = `${triggerRect.bottom + margin}px`
    this.menuTarget.style.left = `${Math.min(
      window.innerWidth - menuWidth - margin,
      Math.max(margin, triggerRect.right - menuWidth)
    )}px`
  }

  select(event) {
    if (event.target.value === "custom") {
      this.showCustomFields()
      this.customDateTarget.disabled = false
      this.customDateTarget.focus()
    } else {
      this.customDateTarget.disabled = true
      this.hideCustomFields()
    }
  }

  showCustomFields() {
    this.customFieldsTarget.classList.remove("hidden")
  }

  hideCustomFields() {
    this.customFieldsTarget.classList.add("hidden")
  }
}
